export default __webpack_public_path__ + "static/media/close.373d0eb4.svg";